import { useId } from 'react';
import './explanation-timeline.css';

export type ExplanationMarker = { id: string; startMs: number; label: string };
const clock = (ms: number) => `${Math.floor(ms / 60000)}:${String(Math.floor(ms / 1000) % 60).padStart(2, '0')}`;

/** Seeking uses the same media clock as speech, ink and tutor pointing. */
export function ExplanationTimeline({ position, duration, markers, disabled = false, onSeek }: {
  position: number; duration: number; markers: ExplanationMarker[];
  disabled?: boolean; onSeek: (at: number) => void;
}) {
  const id = useId();
  const ready = !disabled && Number.isFinite(duration) && duration > 0;
  const points = markers.filter((m, i, all) => Number.isFinite(m.startMs) && m.startMs >= 0 && m.startMs < duration && all.findIndex(n => n.startMs === m.startMs) === i).sort((a, b) => a.startMs - b.startMs);
  const active = points.filter(m => m.startMs <= position).at(-1);
  return <div className="explanation-timeline" aria-label="Explanation playback">
    <div className="explanation-timeline-label"><label htmlFor={id}>Explore this explanation</label><span>{clock(position)} / {clock(duration)}</span></div>
    <input id={id} type="range" min={0} max={duration || 1} step={100} value={Math.min(position, duration || 0)} disabled={!ready}
      aria-valuetext={`${clock(position)} of ${clock(duration)}${active ? `, ${active.label}` : ''}`}
      onChange={e => onSeek(Number(e.target.value))} />
    <div className="explanation-markers" aria-label="Jump to an explanation step">
      {points.map((m, i) => <button key={m.id} type="button" disabled={!ready} title={`${clock(m.startMs)} · ${m.label}`} aria-label={`Jump to step ${i + 1}: ${m.label}`} aria-current={m.id === active?.id ? 'step' : undefined} onClick={() => onSeek(m.startMs)}><span className="explanation-dot" aria-hidden="true"/><span>{i + 1}</span></button>)}
      <span className="explanation-marker-caption">{ready ? active?.label || 'Drag to go back or forward.' : 'Play the explanation to load its timeline.'}</span>
    </div>
  </div>;
}
